import { CommonModule } from '@angular/common'
import { ChangeDetectionStrategy, Component, input, output } from '@angular/core'

import { TooltipModule } from 'primeng/tooltip'

import { AiIconsModule } from '@flowx/designer/modules/new-ai/common/icons/ai-icons.module'

import { AiShortcutComponent, ShortcutConfig } from '../shortcut/shortcut.component'

export enum CommandIcon {
  Process = 'graph-connected',
  Search = 'magnifying-glass',
  Navigate = 'arrow-semi-circ-up-right',
  Info = 'info',
  Action = 'stars-flowx-blue',
}

export type Command = {
  id: string
  title: string
  icon: CommandIcon
  shortcut?: ShortcutConfig
  action: () => void
  disabled?: boolean
  tooltip?: string
}

@Component({
  selector: 'flx-ai-command',
  imports: [CommonModule, TooltipModule, AiIconsModule, AiShortcutComponent],
  templateUrl: './command.component.html',
  styleUrls: ['./command.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class AiCommandComponent {
  title = input<Command['title']>()
  icon = input<Command['icon']>()
  shortcut = input<Command['shortcut']>()
  disabled = input<Command['disabled']>()
  tooltip = input<Command['tooltip']>()
  action = output()

  highlighted = input<boolean>(false)
}
